export enum typesUploading {
    uploadMultiPrint = "uploadMultiPrint",
    uploadFileToAWS = 'uploadFileToAWS',
    uploadFileToDevice = "uploadFileToDevice",
    uploadFileToGoogleDrive = 'uploadFileToGoogleDrive',
    uploadFileToPrintout = 'uploadFileToPrintout'
}